<p-toast></p-toast>

<p-card>    
  
<div class="card">
    <p-toolbar [style]="{'background-color':'#2196f3'}">
        <ng-template pTemplate="left">
            <button pButton pRipple label="NOVO" icon="pi pi-plus" class="p-button-success p-mr-2" (click)="abrirNovo()"></button>
            <!-- <button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedCliente || !selectedCliente.length"></button> -->
      </ng-template>

        <ng-template pTemplate="right">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button>     -->
        </ng-template>
    </p-toolbar>
    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>
   
     <p-table  #dt [value]="produtos" selectionMode="single" [(selection)]="selectedProduto" 
      styleClass="p-datatable-sm p-datatable-striped" dataKey="cod_produto"
      [globalFilterFields]="['produto']"
      [scrollable]="true" scrollHeight="300px">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between" >
                <h2 class="p-m-0">PRODUTOS</h2>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código</th>
                <th>Produto</th>
                <th style="text-align: right;">Valor Custo</th>
                <th style="text-align: right;">Valor Venda</th>
                <th style="text-align: right;">Ações</th>
            </tr>                 
    </ng-template>
   
        <ng-template pTemplate="body" let-produto>
            <tr [pSelectableRow]="produto">
                <td>{{produto.cod_produto}}</td>
                <td>{{produto.produto}}</td>
                <td style="text-align: right;">{{produto.valor_custo | currency:'BRL':true}}</td>
                <td style="text-align: right;">{{produto.valor_venda | currency:'BRL':true}}</td>
                <td style="text-align: right;">
                    <button style="background-color: #3F51B5;" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="Editar(produto)" pTooltip="Editar" tooltipPosition="bottom"></button>
                    <button style="background-color: red; color: white;" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="Deletar(produto)" pTooltip="Deletar" tooltipPosition="bottom"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<hr/>
      <span style="
      background-color: #3F51B5;
      color: white;
      border-radius: 20px;
      padding: 5px;">Registros: {{total}}</span>
</p-card>

<!----=============================================================EDITAR============================================------>
<p-dialog [(visible)]="produtoDialog" [style]="{width: '850px'}" [modal]="true" styleClass="p-fluid">
    <p-header>
        Dados do Produto 
    </p-header>
    <hr/>
    <ng-template pTemplate="content">
       
        <div class="p-grid nested-grid">
            <div class="p-col-8">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="codigo_empresa"><b>Código Empresa</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText id="codigo_empresa" [(ngModel)]="produto.codigo_empresa" required/>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-12">
                        <label for="produto"><b>Produto</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText id="produto" [(ngModel)]="produto.produto" required/>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="categoria"><b>Categoria</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText id="categoria" [(ngModel)]="produto.categoria" required/>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="marca"><b>Marca</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText id="marca" [(ngModel)]="produto.marca" required/>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="localizacao"><b>Localização</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText id="localizacao" [(ngModel)]="produto.localizacao" required/>
                    </div>
        
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="valor_custo"><b>Preço Custo</b></label>
                        <p-inputNumber class="p-inputtext-sm" [(ngModel)]="produto.valor_custo" inputId="valor_custo" 
                        [minFractionDigits]="2"></p-inputNumber>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="valor_venda"><b>Preço Venda</b></label>
                        <p-inputNumber class="p-inputtext-sm" [(ngModel)]="produto.valor_venda" inputId="valor_venda" 
                        [minFractionDigits]="2"></p-inputNumber>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="estoque"><b>Estoque</b></label>
                        <p-inputNumber class="p-inputtext-sm" [(ngModel)]="produto.estoque" inputId="estoque" 
                        [minFractionDigits]="2"></p-inputNumber>
                    </div>
        
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="estoque_minimo"><b>Estoque Minímo</b></label>
                        <p-inputNumber class="p-inputtext-sm" [(ngModel)]="produto.estoque_minimo" inputId="estoque_minimo" 
                        [minFractionDigits]="2"></p-inputNumber>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="estoque_maximo"><b>Estoque Máximo</b></label>
                        <p-inputNumber class="p-inputtext-sm" [(ngModel)]="produto.estoque_maximo" inputId="estoque_maximo" 
                        [minFractionDigits]="2"></p-inputNumber>
                    </div>
        
                    <div class="p-col-12 p-md-6 p-lg-12">
                        <label for="observacao"><b>Observação</b></label>
                        <textarea class="p-inputtext-sm" pInputTextarea [(ngModel)]="produto.observacao"></textarea>
                    </div>
                </div>
            </div>
            <div class="p-col-4" style="text-align: center;align-self: center;">
                 <input type="file" (change)="onFileSelected($event)" pInputText >
                 <!-- <button style="margin-top: 5px;" button pButton pRipple type="button" label="Carregar" 
                 class="p-button-raised" (click)="onUpload()"></button> -->
                <img src="{{path_imagem}}"
                 width="250"/> 
            </div>
        </div>
    </ng-template>
   
    <ng-template pTemplate="footer">
        <hr/>
        
        <button pButton pRipple label="Limpar" icon="pi pi-times-circle" class="p-button-raised p-button-danger" (click)="limparCampos()" style="float: left;"></button>
        <!-- <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-raised p-button-danger" (click)="fecharDialogo()"></button> -->
        <button pButton pRipple label="Incluir" icon="pi pi-check" [disabled]="produto.cod_produto > 0" class="p-button-raised" (click)="Salvar()" ></button>
        <button pButton pRipple label="Alterar" icon="pi pi-check" [disabled]="produto.cod_produto == ''"class="p-button-raised p-button-warning" (click)="Salvar()" style="margin-right: 0px;"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '850px'}"></p-confirmDialog>
